const SESSION = "session-";
const DEVICE_ID = "deviceId-";
export const VISITED_LESSON = "VisitedLessons";
export const DOWNLOADED_LESSON = "DownloadedLessons";
export const SEARCH_TERM = "SearchTerms";
export const USED_FILTER = "UsedFilters";
export const titleBuilder = (deviceId, sessionId) => {
    return DEVICE_ID + deviceId + "/" + SESSION + sessionId;
};
export const visitedLessosTitleBuilder = (deviceId, sessionId, lessonHashedId) => {
    return DEVICE_ID + deviceId + "/" + SESSION + sessionId + "/" + VISITED_LESSON + "/" + lessonHashedId;
};
export const downloadedLessosTitleBuilder = (deviceId, sessionId, lessonHashedId) => {
    return DEVICE_ID + deviceId + "/" + SESSION + sessionId + "/" + DOWNLOADED_LESSON + "/" + lessonHashedId;
};
export const searchTermTitleBuilder = (deviceId, sessionId, searchTermHashedId) => {
    return DEVICE_ID + deviceId + "/" + SESSION + sessionId + "/" + SEARCH_TERM + "/" + searchTermHashedId;
};
export const usedFilterTitleBuilder = (deviceId, sessionId, filterNameHashedId) => {
    return DEVICE_ID + deviceId + "/" + SESSION + sessionId + "/" + USED_FILTER + "/" + filterNameHashedId;
};
